import React from "react";
import PropTypes from "prop-types";

import Avatar from "components/Avatar";
import Tooltip from "components/Tooltip";

import styles from "./Collaborators.css";

const Collaborators = ({ collaborators }) => (
  <div className={styles.root}>
    {collaborators.map((collaborator) => (
      <div className={styles.collaborator} key={`collaborator_${collaborator.id}`}>
        <Tooltip
          tip={
            <Avatar
              fname={collaborator.fname}
              lname={collaborator.lname}
              size="small"
              src={collaborator.profilePictureUrl}
            />
          }
        >
          {collaborator.fname} {collaborator.lname}
        </Tooltip>
      </div>
    ))}
  </div>
);

Collaborators.propTypes = {
  collaborators: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      fname: PropTypes.string,
      lname: PropTypes.string,
      profilePictureUrl: PropTypes.string,
      title: PropTypes.string,
      company: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
      }),
    })
  ),
};

export default Collaborators;
